<template>
  <div class='animated fadeIn'>
    <b-row v-if="$route.name === 'Administrators'">
      <b-col lg='12'>
        <h4 class="card-title"> <b>Administrators</b> List</h4>
          <b-row>
            <b-col lg='4' md='6'>
              <b-form-group
                label="Name"
                label-for="visitType"
                :label-cols="3"
                :horizontal="true">
                <text-input-del-btn id="exampleInput2"
                  type="text"
                  v-model="filterBy.search"
                  placeholder="">
                </text-input-del-btn>
              </b-form-group>
            </b-col>
            <b-col lg='2' md='2'>
              <b-button variant="success" class="btn-rounded mb-3" @click="doFilter()">
                <i class="fa fa-search"></i>
              </b-button>
            </b-col>
            <b-col lg='6' md='4' class="text-right">
              <b-button href="#/settings/user/admin/create" size="lg" class="btn-rounded mb-3" variant="success">
                <i class="fa fa-plus"></i>
              </b-button>
            </b-col>
          </b-row>

          <c-server-table
            :url="apiUrl"
            :columns="columns"
            :options="options"
            :method_1="doUpdateStatus"
            ref="dataTable"
            >
          </c-server-table>

      </b-col><!--/.col-->
    </b-row><!--/.row-->
    <router-view></router-view>
  </div>
</template>

<script>
import axios from 'axios'
import cServerTable from '@/views/components/cServerTable'
import TextInputDelBtn from '@/views/components/forms/TextInputDelBtn'

export default {
  name: 'userIndex',
  components: {
    cServerTable,
    TextInputDelBtn
  },
  data () {
    // table config
    let config = cServerTable.methods.setTableConfig({
      columns: [
        'firstName',
        'email',
        'phone',
        // 'address',
        // 'unit',
        'isActive',
        'actionButtons'
      ],
      options: {
        headings: {
          firstName: 'Username',
          email: 'Email',
          phone: 'Phone',
          address: 'Address',
          unit: 'Unit',
          isActive: 'Availability',
          actionButtons: ''
        },
        templates: {
          firstName (h, row) {
            return row.firstName + ' ' + (window.setDefaultNull(row.lastName, ''))
          }
        },
        sortable: ['username', 'role', 'isActive'],
        uniqueKey: 'uuid',
        params: {
          search: this.$route.query.search,
          role: 'admin'
        }
      }
    }, 'profile')

    // data returned
    return {
      apiUrl: window.AppConfig.apiUrl + 'profile',
      apiUrlUpdateStatus: window.AppConfig.apiUrl + 'user-activated',
      // vue-table-2 config
      columns: config.columns,
      options: config.options,
      // filter var
      filterBy: {
        search: window.setDefaultNull(this.$route.query.search)
      }
    }
  },
  mounted () {
  },
  methods: {
    doFilter () {
      this.options.params.search = this.filterBy.search === '' ? null : this.filterBy.search
      this.$refs.dataTable.setTableDatas()
    },
    doUpdateStatus (row) {
      let data = {
        uuid: row.uuid,
        isActive: !row.isActive ? 1 : 0
      }
      axios.post(this.apiUrlUpdateStatus, data)
        .then(response => {
          row.isActive = data.isActive ? 1 : 0
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/settings/admin/Index.vue